import {AddSchema} from "mobx-graphlink";
import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";

export class EngineConfig_JourneyEntry {
	constructor(initialData: Partial<EngineConfig_JourneyEntry>) { Object.assign(this, initialData); }

	enabled: boolean;

	// triggers
	prevEntity_triggerSet: TriggerSet;
	nextEntity_triggerSet: TriggerSet;
	// todo: add customization of the other triggers
	/*moreActions_triggerSet: TriggerSet;
	mainAction_triggerSet: TriggerSet;*/

	voiceSoundTag: string;
	volumeMultiplier: number;
}
AddSchema("EngineConfig_JourneyEntry", {
	properties: {
		enabled: {type: "boolean"},

		prevEntity_triggerSet: {$ref: "TriggerSet"},
		nextEntity_triggerSet: {$ref: "TriggerSet"},
		/*moreActions_triggerSet: {$ref: "TriggerSet"},
		mainAction_triggerSet: {$ref: "TriggerSet"},*/

		voiceSoundTag: {type: "string"},
		volumeMultiplier: {type: "number"},
	},
});